import { Chip } from '@mui/material';

export function PedidoPrioritarioChip({ size = 'medium' }: { size?: 'small' | 'medium' }) {
    return (
        <Chip
            size={size}
            label="Prioritário"
            color="error"
            sx={{
                height: size === 'small' ? 20 : 24,
                fontSize: size === 'small' ? 13 : 14,
                fontWeight: 500,
            }}
        />
    );
}
